import { render, staticRenderFns } from "./BadgeSelect.vue?vue&type=template&id=7b6a65d4&scoped=true&"
import script from "./BadgeSelect.vue?vue&type=script&lang=ts&"
export * from "./BadgeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeSelect.vue?vue&type=style&index=0&id=7b6a65d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6a65d4",
  null
  
)

export default component.exports